export default "<div class=\"sample-page-box\"><markdown [data]=\"legalNotice\"></markdown></div>\n";